import { UiTheme } from '@jarvis/react-setup-and-onboarding-addons'
import { Stack } from '@jarvis/web-stratus-client'

import { ConfigStore } from './config.store'

import { Locale, ServiceRoutingOptions } from '@/types/general'
import { getCommonsNorthboundAPIs } from '@foreign-clientos/dependency-manager'

export const setLocale = (locale: Locale) => ConfigStore.setState({ locale })

export const setStack = (stack: Stack) => ConfigStore.setState({ stack })

export const setUi = (ui: keyof typeof UiTheme) => ConfigStore.setState({ ui })

export async function loadAppSessionId() {
  try {
    const serviceLaunchOptions =
      await getCommonsNorthboundAPIs().v1.serviceRouting.getServiceInstanceLaunchOptions()
    if ('serviceOptions' in serviceLaunchOptions) {
      ConfigStore.setState({
        // Casting due the weak typing in JWEB and ClientOS side
        appSessionId: (
          serviceLaunchOptions.serviceOptions as ServiceRoutingOptions
        )?.appSessionId,
      })
    }
  } catch (error) {
    OobeLogger.error(
      'Not able to get app session ID from v1.serviceRouting.getServiceInstanceLaunchOptions',
      error,
    )
  }
}
